import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import routes from './routes'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Navbar from './components/navbar'
import '../src/scss/customBootstrap.scss'
import CollapsableMenu from './components/collapsableMenu'
import { NavBarContextProvider } from './helpers/context'
import { useWindowSize } from './helpers/hooks/hookWindowsSize'

function App() {
  const sizeWidth = useWindowSize().width

  return (
    <>
      <BrowserRouter>
        <ToastContainer hideProgressBar={true} autoClose={10000} />
        <Provider store={store}>
          <NavBarContextProvider>
            <div className="App">
              <Navbar />
              <div className="principal-container">
                {sizeWidth > 768 && <CollapsableMenu />}

                <Routes>
                  {routes.map(({ path, Component }, index) => (
                    <Route key={index} path={path} element={<Component />} />
                  ))}
                </Routes>
              </div>
            </div>
          </NavBarContextProvider>
        </Provider>
      </BrowserRouter>
    </>
  )
}

export default App
